export default __webpack_public_path__ + "static/media/165d836fc648d30d4af54b068b19182e.png";